export const ACCOUNT_PROFILE_PAGE_LINK_EDIT_FORM_QUERY = '?profileEdit=true';
export const RETURN_ITEM_REDIRECT_PREFIX = 'return-item-';
